export default __webpack_public_path__ + "static/media/office1-after2-768w.0b66f5de.avif";